export const CONTACT_SUPPORT_LINK = '[CONTACT_SUPPORT_LINK]';
